import { array, boolean, date, number, object, string } from "yup";

import {
  AgeRange,
  AnnualIncome,
  Browser,
  DeliverDayOfWeekInput,
  DeliverKind,
  Device,
  Gender,
  Platform,
  PopupGroupDeliverUrlInput,
  PopupGroupDisableTargetElement,
  PopupGroupDisplayTargetContent,
  PopupGroupExcludeReferrerInput,
  PopupGroupReferrerInput,
  PopupGroupTargetCookieInput,
  VisitMatch,
} from "~/src/__generated__/schema";

export type FormValues = {
  ageRanges: AgeRange[];
  annualIncomes: AnnualIncome[];
  browsers: Browser[];
  deliverKind: DeliverKind;
  deliverTargetUrls: PopupGroupDeliverUrlInput[];
  deliverExcludeUrls: PopupGroupDeliverUrlInput[];
  deliverDayOfWeeks: DeliverDayOfWeekInput[];
  devices: Device[];
  displayTargetContents: PopupGroupDisplayTargetContent[];
  disableTargetElements: PopupGroupDisableTargetElement[];
  endDate: Date | null;
  excludeReferrers: PopupGroupExcludeReferrerInput[];
  funnelId: string;
  genders: Gender[];
  isContentAnalyticsEnabled: boolean;
  isMulti: string;
  memo: string | null;
  name: string;
  pageId: string;
  startDate: Date | null;
  platforms: Platform[];
  redisplayPopupTime: number;
  referrers: PopupGroupReferrerInput[];
  sourceIds: string[];
  excludeSourceIds: string[];
  targetCookies: PopupGroupTargetCookieInput[];
  visitCount: number | null;
  visitMatchType: VisitMatch;
  scheduleIds: string[];
};

export const validationSchema = object({
  ageRanges: array().of(string()),
  annualIncomes: array().of(string()),
  browsers: array().of(string()),
  deliverKind: string().required(),
  devices: array().of(string()),
  endDatetime: date().nullable(),
  genders: array().of(string()),
  isContentAnalyticsEnabled: boolean().required(),
  isMulti: string().required(),
  memo: string().nullable(),
  name: string().required().max(50),
  sourceIds: array().of(string()),
  excludeSourceIds: array().of(string()),
  startDatetime: date().nullable(),
  platforms: array().of(string()),
  visitCount: number().nullable(),
  visitMatchType: string().nullable(),
  scheduleIds: array().of(string()),
});
